module.exports = __webpack_public_path__ + "static/media/rewind-icon-light.874e4718.svg";